export default __webpack_public_path__ + "static/O0023-1e510d2c5f2b1313e24b7545ce1ad3f8.png";